import { getHeaderSectionHeight } from "../helpers/HeaderSection";

/**
 * @class CollectionPagination
 */
class CollectionPagination {
  constructor() {
    this.data = [];

    window.requestAnimationFrame(() => {
      this.refresh();
    });
  }

  refresh() {
    this.areas = document.querySelectorAll(".template-collection__content");

    const variantFromCookie = this.getPaginationVariant();
    this.autoLoad = variantFromCookie === "load_more_auto";
    this.variant =
      variantFromCookie === "load_more_auto" ? "load_more" : variantFromCookie;

    document
      .querySelectorAll(".template-collection__products .pagination__wrapper")
      .forEach((area) => area.classList.remove("pagination--preloader"));

    this.showVariantPagination();
    this.listenerClickButtons();
    this.initObserver();

    if (this.autoLoad) {
      this.initLoadMoreAuto();
    }
  }

  initObserver() {
    const productsWrapper = document.querySelector(
      ".template-collection__products"
    );
    if (!productsWrapper || !window.MutationObserver) return;

    if (this.observer) {
      this.observer.disconnect();
    }

    const observer = new MutationObserver(() => {
      this.showVariantPagination();
    });

    observer.observe(productsWrapper, { childList: true, subtree: true });
    this.observer = observer;
  }

  showVariantPagination() {
    document
      .querySelectorAll(".template-collection__products .pagination__wrapper")
      .forEach((wrapper) => {
        const system = wrapper.dataset.system;
        if (system === this.variant) {
          wrapper.classList.remove("hide");
        } else {
          wrapper.classList.add("hide");
        }
      });
  }

  getPaginationVariant() {
    // const match = document.cookie.match(/(?:^|;\s*)pagination_variant=(\w+)/);
    // if (match && match[1]) {
    //   return match[1];
    // }
    return (
      document.querySelector(".template-collection__products")?.dataset
        ?.paginationSystem || "load_more"
    );
  }

  listenerClickButtons() {
    [...this.areas].forEach((area) => {
      if (area.dataset.paginationEventsBound === "true") {
        return;
      }
      area.dataset.paginationEventsBound = "true";
      area.addEventListener("click", (event) => {
        this.clickButton(event);
      });
    });
  }

  async clickButton(event) {
    const selector = ".pagination__link";
    const selector2 = ".pagination--load-more";
    let item = event.target.closest(selector);
    if (!item && event.target.classList.contains(selector.substring(1))) {
      item = event.target;
    } else if (
      !item &&
      event.target.classList.contains(selector2.substring(1))
    ) {
      item = event.target;
    } else if (!item && event.target.closest(selector2)) {
      item = event.target.closest(selector2);
    }

    if (item) {
      event.preventDefault();

      const wrapper = item.closest(".template-collection__products");
      const pagination_wrapper = item.closest(".pagination__wrapper");
      const pagination_system =
        pagination_wrapper?.dataset?.system || "default";

      if (wrapper && !item.classList.contains("gld-btn--loading")) {
        item.classList.add("gld-btn--loading");
        wrapper.classList.add("preloader");

        const url = this.setURL(item.getAttribute("href"), event);
        const data = await this.getData(url);
        if (data) {
          const products = new DOMParser()
            .parseFromString(data, "text/html")
            .querySelector(".template-collection__products");
          if (products) {
            if (pagination_system === "load_more") {
              this.renderItemsLoadMore(products, item, wrapper);
            } else {
              wrapper.innerHTML = products.innerHTML.replaceAll(
                "pagination--preloader",
                ""
              );
            }
            this.updateURLHash(url);
            this.showVariantPagination();
          }
        }

        if (window.LazyLoaderRun) {
          window.LazyLoaderRun();
        }
        if (window.dy_productCardPerformance) {
          window.dy_productCardPerformance();
        }

        window.callbacks_pagination_after_change =
          window.callbacks_pagination_after_change || [];
        if (window?.callbacks_pagination_after_change.length) {
          window.callbacks_pagination_after_change.forEach((callback) =>
            callback()
          );
        }

        wrapper.classList.remove("preloader");
        item.classList.remove("gld-btn--loading");
        this.srollToTopSection(item, wrapper, pagination_system);
      }
    }
  }

  renderItemsLoadMore(products, btn, wrapper) {
    const items = [
      ...products.querySelectorAll(".template-collection__products__item"),
    ];
    const pagination__wrapper_prev = products.querySelector(
      ".pagination--load-more--prev"
    );
    const pagination__wrapper_next = products.querySelector(
      ".pagination--load-more--next"
    );
    const list = wrapper.querySelector(".template-collection__products__list");

    if (items.length) {
      if (btn.dataset.button === "prev") {
        items.reverse().forEach((item) => list.prepend(item));

        if (pagination__wrapper_prev) {
          wrapper.querySelector(".pagination--load-more--prev").innerHTML =
            pagination__wrapper_prev.innerHTML.replaceAll(
              "pagination--preloader",
              ""
            );
        }
      } else if (btn.dataset.button === "next") {
        items.forEach((item) => list.appendChild(item));

        if (pagination__wrapper_next) {
          wrapper.querySelector(".pagination--load-more--next").innerHTML =
            pagination__wrapper_next.innerHTML.replaceAll(
              "pagination--preloader",
              ""
            );
        }
      }
    }

    if (this.autoLoad) {
      this.initLoadMoreAuto();
    }
  }

  srollToTopSection(btn, wrapper, pagination_system) {
    let scrollBreakpoint =
      wrapper.getBoundingClientRect().top -
      getHeaderSectionHeight() -
      20 +
      window.scrollY;

    if (pagination_system === "load_more" && btn.dataset.button === "next") {
      scrollBreakpoint = window.scrollY;
    }

    if (scrollBreakpoint) {
      window.scrollTo({ top: scrollBreakpoint, behavior: "smooth" });
    }
  }

  setURL(url, event) {
    const urlData = new URL(url, window.location.origin);
    const searchParams = urlData.searchParams;
    const wrapper = event.target.closest(
      ".colection-template__section-wrapper"
    );
    if (wrapper?.dataset?.sectionId) {
      searchParams.set("section_id", wrapper.dataset.sectionId);
    }
    if (!searchParams.has("limit")) {
      const products = event.target.closest(".template-collection__products");
      if (products?.dataset?.limit) {
        searchParams.set("limit", products.dataset.limit);
      }
    }

    return `${urlData.pathname}${urlData.search}`;
  }

  async getData(url) {
    const filterDataUrl = (element) => element.url === url;
    const data = this.data.some(filterDataUrl)
      ? this.getDataFromCache(filterDataUrl)
      : await this.getDataFromFetch(url);
    return data;
  }

  getDataFromCache(filterDataUrl) {
    const html = this.data.find(filterDataUrl).html;
    return html;
  }

  async getDataFromFetch(url) {
    const query = await fetch(url);
    const responseText = await query.text();
    if (responseText) {
      const html = responseText;
      this.data = [...this.data, { html, url }];
      return html;
    }
    return null;
  }

  updateURLHash(url) {
    url = window.location.origin + url;
    const url_data = new URL(url);
    const searchParams = new URLSearchParams(url_data.search);
    searchParams.delete("view");
    searchParams.delete("section_id");

    if (searchParams.get("page") === "1") {
      searchParams.delete("page");
    }

    const params = searchParams.toString();
    history.pushState(
      { params },
      "",
      `${window.location.pathname}${params && "?".concat(params)}`
    );
  }

  initLoadMoreAuto() {
    const btnNext = document.querySelector(
      ".template-collection__products .pagination--load-more--next .pagination--load-more[data-button='next']"
    );

    if (!btnNext) return;

    Object.assign(btnNext.style, {
      background: "none",
      textIndent: "-1000em",
      pointerEvents: "none",
    });

    if (this.loadMoreObserver) {
      this.loadMoreObserver.disconnect();
    }

    this.loadMoreObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (
            entry.isIntersecting &&
            !btnNext.classList.contains("gld-btn--loading")
          ) {
            btnNext.click();
          }
        });
      },
      {
        rootMargin: "0px 0px 0px 0px",
        threshold: 0.1,
      }
    );

    this.loadMoreObserver.observe(btnNext);
  }
}

export default CollectionPagination;
